import { useMutation, useQueryClient } from '@tanstack/react-query';

import { _notificationsRead } from './mutations';
import { NOTIFICATIONS_QUERY_KEYS } from './types';

type Options = {
  onSuccess?: () => void;
};

export const useMarkNotificationAsRead = ({ onSuccess }: Options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: _notificationsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEYS.notifications] });
      onSuccess?.();
    },
  });
};
